/* Aceites — global utilities. Add shared helpers here as the theme grows. */
(function () {
  'use strict';

  window.Aceites = window.Aceites || {};

  Aceites.formatMoney = function (cents) {
    var n = (cents || 0) / 100;
    return n.toFixed(2);
  };

  Aceites.debounce = function (fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  };
})();
